import dynamic from 'next/dynamic'

export const DynamicMembershipSuccessModal = dynamic(
  () => import('.').then((mod) => mod.MembershipSuccessModal),
  { ssr: false },
)
